import React from "react";

export const Header = (props) => {
  return (
<header id="header">
  <div className="intro">
    <div className="overlay">
      <div className="container">
        <div className="row">
          <div className="col-md-8 col-md-offset-2 intro-text text-center">
            {props.data ? (
              <img
                className="intro-img"
                title={props.data.title}
                src={props.data.image}
                alt={props.data.title}
              />
            ) : (
              "Loading"
            )}
            <p className="h3">{props.data ? props.data.paragraph : "Loading"}</p>
            <a href="#features" className="btn btn-custom btn-lg page-scroll">
              Read more
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</header>


  );
};
